import { SDKs } from "~/constants/routes";

import { SDKProps, DefaultContext } from "~/types";

import localContentDeprecatedDefaults from "~/sdks/LocalContentDeprecated/defaultState";
import localContentDefaults from "~/sdks/LocalContent/defaultState";
import localDemographicsDefaults from "~/sdks/LocalDemographics/defaultState";
import locallNeighborhoodMapsDefaults from "~/sdks/NeighborhoodMap/defaultState";
import neighborhoodHeroDefaults from "~/sdks/NeighborhoodHero/defaultState";
import neighborhoodCharacteristicsDefaults from "~/sdks/NeighborhoodCharacteristics/defaultState";
import neighborhoodDemographicsDefaults from "~/sdks/NeighborhoodDemographics/defaultState";
import neighborhoodHighlightsDefaults from "~/sdks/NeighborhoodHighlights/defaultState";
import neighborhoodPropertyValueDriversDefaults from "~/sdks/NeighborhoodPropertyValueDrivers/defaultState";
import neighborhoodMatchDefaults from "~/sdks/NeighborhoodMatch/defaultState";
import neighborhoodMarketTrendsDefaults from "~/sdks/NeighborhoodMarketTrends/defaultState";
import neighborhoodSchools from "~/sdks/NeighborhoodSchools/defaultState";
import neighborhoodShowcase from "~/sdks/NeighborhoodShowcase/defaultState";
import neighborhoodFeatured from "~/sdks/NeighborhoodFeatured/defaultState";

const globalDefaults: Partial<
  DefaultContext<SDKProps>["sdkState"]["globalOptions"]
> = {
  locale: "en",
};

const defaultState: Record<
  SDKs,
  {
    globalOptions: DefaultContext<SDKProps>["sdkState"]["globalOptions"];
    options: Partial<DefaultContext<SDKProps>["sdkState"]["options"]>;
  }
> = {
  "local-content": {
    globalOptions: globalDefaults,
    options: localContentDeprecatedDefaults,
  },
  "local-content-google-maps": {
    globalOptions: globalDefaults,
    options: localContentDefaults,
  },
  "local-content-refresh": {
    globalOptions: globalDefaults,
    options: localContentDefaults,
  },
  "local-demographics": {
    globalOptions: globalDefaults,
    options: localDemographicsDefaults,
  },
  "neighborhood-map": {
    globalOptions: globalDefaults,
    options: locallNeighborhoodMapsDefaults,
  },
  "neighborhood-hero": {
    globalOptions: globalDefaults,
    options: neighborhoodHeroDefaults,
  },
  "neighborhood-characteristics": {
    globalOptions: globalDefaults,
    options: neighborhoodCharacteristicsDefaults,
  },
  "neighborhood-highlights": {
    globalOptions: globalDefaults,
    options: neighborhoodHighlightsDefaults,
  },
  "neighborhood-demographics": {
    globalOptions: globalDefaults,
    options: neighborhoodDemographicsDefaults,
  },
  "neighborhood-property-value-drivers": {
    globalOptions: globalDefaults,
    options: neighborhoodPropertyValueDriversDefaults,
  },
  "neighborhood-match": {
    globalOptions: globalDefaults,
    options: neighborhoodMatchDefaults,
  },
  "neighborhood-market-trends": {
    globalOptions: globalDefaults,
    options: neighborhoodMarketTrendsDefaults,
  },
  "neighborhood-schools": {
    globalOptions: globalDefaults,
    options: neighborhoodSchools,
  },
  "neighborhood-showcase": {
    globalOptions: globalDefaults,
    options: neighborhoodShowcase,
  },
  "neighborhood-featured": {
    globalOptions: globalDefaults,
    options: neighborhoodFeatured,
  },

  // Legacy name, do NOT remove
  // @ts-expect-error-next-line
  demographics: {
    globalOptions: globalDefaults,
    options: localDemographicsDefaults,
  },

  // TODO: LL22-5170 Remove these once the try site has been updated to use the new names
  "local-neighborhood-map": {
    globalOptions: globalDefaults,
    options: locallNeighborhoodMapsDefaults,
  },
  "local-neighborhood-hero": {
    globalOptions: globalDefaults,
    options: neighborhoodHeroDefaults,
  },
  "local-neighborhood-characteristics": {
    globalOptions: globalDefaults,
    options: neighborhoodCharacteristicsDefaults,
  },
  "local-neighborhood-highlights": {
    globalOptions: globalDefaults,
    options: neighborhoodHighlightsDefaults,
  },
  "local-neighborhood-demographics": {
    globalOptions: globalDefaults,
    options: neighborhoodDemographicsDefaults,
  },
  "local-neighborhood-property-value-drivers": {
    globalOptions: globalDefaults,
    options: neighborhoodPropertyValueDriversDefaults,
  },
  "local-neighborhood-match": {
    globalOptions: globalDefaults,
    options: neighborhoodMatchDefaults,
  },
};

export default defaultState;
